import { useFormaliteService } from '@europrocurement/l2d-domain';
import { CollectionOpenSearchJsonldOpensearchCollectionOfferRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type OrderOffer = CollectionOpenSearchJsonldOpensearchCollectionOfferRead &
    Record<string, unknown>;

const useOrderOffer = () => {
    const { collectionOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchOrderOffer = (term: string): Promise<Array<OrderOffer>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term || undefined };

            searchTimeout = setTimeout(() => {
                collectionOpenSearchApi
                    .apiOpensearchCollectionsOffersGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OrderOffer>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchOrderOffer };
};

export default useOrderOffer;
